/*
 * Copyright (C) Fraunhofer IESE 2026
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */

import {
    GlobalErrorResponse,
    ResponseError
} from '@slr/user-service-external-sdk';

export async function parseUserServiceUniqueExceptionType(
  error: unknown
): Promise<string | undefined> {
  if (!(error instanceof ResponseError)) {
    return undefined;
  }

  try {
    const errorBody = (await error.response.json()) as GlobalErrorResponse;
    return errorBody.uniqueExceptionType;
  } catch {
    return undefined;
  }
}
